import Button from "@elements/Button";

const defaultProps = {
  onClick: () => {},
};

export default function ModalCancelButton(props) {
  const onClick = props.onClick || defaultProps.onClick;

  return (
    <Button
      value="Cancel"
      type="reset"
      onClick={onClick}
    />
  );
}
